export class EmailModel{
    to:string;
    employeeCode: string;
    subject:string;
    html: string
}